var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component, { mixins } from 'vue-class-component';
import { CookieEnum, LocaleEnum } from '@vini-wine/core-enums';
import ViniCookies from '@/mixin/viniCookies';
// eslint-disable-next-line no-use-before-define
let LocaleMixin = class LocaleMixin extends mixins(ViniCookies) {
    get currentLocale() {
        // when locale changes re-call the function
        const { locale } = this.$i18n;
        const localeFromCookie = this.getCookie(CookieEnum.SELECTED_LOCALE);
        if (localeFromCookie)
            return localeFromCookie;
        const localeFromStorage = localStorage.getItem(CookieEnum.SELECTED_LOCALE);
        if (localeFromStorage)
            return localeFromStorage;
        // fallback
        return LocaleEnum.ENGLISH;
    }
    changeLocale(locale) {
        localStorage.setItem(CookieEnum.SELECTED_LOCALE, locale);
        this.setCookie(CookieEnum.SELECTED_LOCALE, locale);
        this.$i18n.locale = locale;
    }
};
LocaleMixin = __decorate([
    Component({
        mounted() {
            this.$i18n.locale = this.currentLocale;
        },
    })
], LocaleMixin);
export default LocaleMixin;
